import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `fetchStaffMembers`/`createStaffMember`/`updateStaffMember`/`deleteStaffMember`. */
const StaffMembersNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="STAFF_MEMBER_CREATED"
				title="Personnel créé"
				message="Le membre du personnel a bien été créé."
			/>
			<SuccessNotification
				eventName="STAFF_MEMBER_UPDATED"
				title="Personnel modifié"
				message="Le membre du personnel a bien été modifié."
			/>
			<SuccessNotification
				eventName="STAFF_MEMBER_DELETED"
				title="Personnel supprimé"
				message="Le membre du personnel a bien été supprimé."
			/>
			<ErrorNotification
				eventName="STAFF_MEMBER_CREATION_FAILED"
				title="Erreur"
				message="Le membre du personnel n’a pas pu être créé."
			/>
			<ErrorNotification
				eventName="STAFF_MEMBER_UPDATE_FAILED"
				title="Erreur"
				message="Le membre du personnel n’a pas pu être modifié."
			/>
			<ErrorNotification
				eventName="STAFF_MEMBER_DELETION_FAILED"
				title="Erreur"
				message="Le membre du personnel n’a pas pu être supprimé."
			/>
			<ErrorNotification
				eventName="STAFF_MEMBERS_FETCH_FAILED"
				title="Erreur"
				message="La liste du personnel n’a pas pu être chargée."
			/>
		</React.Fragment>
	);
};

export default StaffMembersNotifications;
